var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVrAssistant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 27,
    fill: "#F45B23"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(32 32) scale(1.28) translate(-32 -32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 24C24 20.6863 27.5817 18 32 18C36.4183 18 40 20.6863 40 24",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 28C20 22.4772 25.3726 18 32 18C38.6274 18 44 22.4772 44 28",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 28,
    width: 4,
    height: 8,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 28,
    width: 4,
    height: 8,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 30,
    r: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 30,
    r: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42,
    y1: 36,
    x2: 32,
    y2: 36,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVrAssistant);
export default __webpack_public_path__ + "static/media/vr_assistant.36cf80f3189d7144ed7a734dba702fa5.svg";
export { ForwardRef as ReactComponent };